import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addClientData } from "../../../../../data/redux/slice/clientOnboardDataSlice";
import { modalNavigation } from "../../../../../data/redux/slice/modalNavigationSlice";
import CustomStepper from "../../../../components/ui_comps/CustomStepper";
import BasicDetails from "./BasicDetails";
import ClientBankDetails from "./ClientBankDetails";
import ClientFileUploads from "./ClientFileUploads";
import ResellerDetails1 from "./ResellerDetails1";
import RollingReserve from "./RollingReserve";

function ClientOnboardIndex({ onSuccess, onClose }) {
  const [currentStep, setCurrentStep] = useState(1);

  const currentModalStep = useSelector((state) => state.modalNavSlice);
  const dispatch = useDispatch();

  const clientData = useSelector((state) => state.onboardClientSlice);
  useEffect(() => {
    setCurrentStep(currentModalStep);
  }, [currentModalStep]);

  return (
    <div
      style={{
        // maxWidth: 550,
        // minWidth: 350,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CustomStepper totalStep={5} currentStep={currentStep} />

      <div
        style={{
          width: "100%",
          height: "100%",
          marginTop: 10,
          padding: "0px 15px",
        }}
      >
        {currentStep === 1 ? (
          <BasicDetails
            onClickBack={() => {
              onClose();
            }}
            onClickNext={(data) => {
              setCurrentStep(2);
              dispatch(modalNavigation(2));
              dispatch(
                addClientData({
                  ...data,
                })
              );
            }}
            isAddressRequired={true}
            reduxData={clientData}
          />
        ) : currentStep === 2 ? (
          <ClientBankDetails
            onClickBack={onClose}
            onClickNext={(data) => {
              setCurrentStep(3);
              dispatch(modalNavigation(3));
              dispatch(addClientData({ ...data }));
            }}
            reduxData={clientData}
          />
        ) : currentStep === 3 ? (
          <ClientFileUploads
            onClickBack={onClose}
            onClickNext={(data) => {
              setCurrentStep(4);
              dispatch(modalNavigation(4));
              dispatch(addClientData({ ...data }));
            }}
            reduxData={clientData}
          />
        ) : currentStep === 4 ? (
          <ResellerDetails1
            reduxData={clientData}
            onClickNext={(data) => {
              setCurrentStep(5);
              dispatch(modalNavigation(5));
              dispatch(addClientData({ ...data }));
            }}
            onClickBack={onClose}
          />
        ) : currentStep === 5 ? (
          <RollingReserve
            reduxData={clientData}
            onSuccess={onSuccess}
            onClickBack={onClose}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default ClientOnboardIndex;
